import { ILdRequestContext, UserRoleType } from './feature-flag-model';
import { User } from '@auth0/auth0-angular';

export function createUserContext(inputObject: User, apiUrl: string): ILdRequestContext {
	let userMetaDataKey: string = `${apiUrl}/user_metadata`;
	let userRoleKey: string = `${apiUrl}/roles`;
	let requestContext: ILdRequestContext = {
		kind: 'multi',
		user: {},
		organization: {},
	};
	let role: UserRoleType;
	for (let key in inputObject) {
		key === userRoleKey ? (role = inputObject[key][0]) : '';

		if (key === userMetaDataKey) {
			if (
				inputObject[userMetaDataKey].org_id &&
				inputObject[userMetaDataKey]?.company &&
				inputObject[userMetaDataKey]?.user_uuid
			) {
				let contextKey = inputObject[key].user_uuid + '_' + '*' + '_' + inputObject[userMetaDataKey].org_id;

				requestContext.user = {
					key: contextKey,
					userId: inputObject[userMetaDataKey].user_uuid,
					role,
				};

				requestContext.organization = {
					key: contextKey,
					companyName: inputObject[userMetaDataKey].company,
					orgId: inputObject[userMetaDataKey].org_id,
				};
				break;
			}
		}
	}
	return requestContext;
}
